import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { msg } from '@lingui/macro';

export type PanelCheckbox = 'healthStatus';

export interface ControlCenterState {
  panelCheckboxes: Record<PanelCheckbox, { display: boolean; checked: boolean }>;
  selectedIrrigationIds: number[];
  minichartsQueryPeriod: {
    label: ReturnType<typeof msg>;
    start: '-1h' | '-3h' | '-6h' | '-12h' | '-1d' | '-3d' | '-7d' | '-15d' | '-1mo';
    window: '5m' | '15m' | '30m' | '1h' | '3h' | '6h' | '12h' | '1d';
  };
}

const initialState: ControlCenterState = {
  panelCheckboxes: {
    healthStatus: { display: false, checked: false },
  },
  selectedIrrigationIds: [],
  minichartsQueryPeriod: { label: msg`1 día`, start: '-1d', window: '1h' },
};

const controlCenterSlice = createSlice({
  name: 'control_center_store',
  initialState,
  reducers: {
    togglePanelCheckbox(
      state,
      action: PayloadAction<{
        checkboxName: keyof typeof initialState.panelCheckboxes;
        checked?: boolean;
      }>,
    ) {
      const { checkboxName, checked } = action.payload;
      state.panelCheckboxes[checkboxName].checked =
        checked ?? !state.panelCheckboxes[checkboxName].checked;
    },
    setDisplayPanelCheckbox(
      state,
      action: PayloadAction<{
        checkboxName: keyof typeof initialState.panelCheckboxes;
        display: boolean;
      }>,
    ) {
      const { checkboxName, display } = action.payload;
      state.panelCheckboxes[checkboxName].display = display;
    },
    setSelectedIrrigationIds(state, action: PayloadAction<number[]>) {
      state.selectedIrrigationIds = action.payload;
    },
    setMinichartsQueryPeriod(
      state,
      action: PayloadAction<ControlCenterState['minichartsQueryPeriod']>,
    ) {
      state.minichartsQueryPeriod = action.payload;
    },
  },
});

const { actions, reducer } = controlCenterSlice;

export const {
  togglePanelCheckbox,
  setDisplayPanelCheckbox,
  setSelectedIrrigationIds,
  setMinichartsQueryPeriod: setMinichartQueryPeriod,
} = actions;
export default reducer;
